import { EHashLinks } from '@enum';

import {
  HomeIcon,
  ContactsIcon,
  EducationIcon,
  ExperienceIcon,
} from '@assets/icons';

import { LinkIconProps } from './LinkIcon.types';

export const LinkIcon = ({ type }: LinkIconProps) => {
  if (type === EHashLinks.education) return <EducationIcon />;
  if (type === EHashLinks.experience) return <ExperienceIcon />;
  if (type === EHashLinks.profile) return <ContactsIcon />;
  return <HomeIcon />;
};
